import angular from 'angular';
import eventDetailComponent from './event-detail.component';
import EventDetailService from './event-detail.service';
import eventDetailConfig from './event-detail.config';


let eventDetailModule = angular.module('eventDetail',[])
  .component('eventDetail', eventDetailComponent)
  .service('eventDetailService', EventDetailService)
  .config(eventDetailConfig);

export default eventDetailModule;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/events/event-detail/event-detail.js
 **/